// Données spécifiques à la PAGE CLASSIQUE (hors promo)
import {
  FREQUENCES,
  CLOUD_TIMELINE,
  MODULES,
  TESTIMONIALS,
  VIDEO_TESTIMONIALS,
  SCREENSHOTS,
  BONUS,
  PHASE2,
  LINKS,
} from "../mock";

export { FREQUENCES, CLOUD_TIMELINE, MODULES, VIDEO_TESTIMONIALS, SCREENSHOTS, PHASE2, LINKS };

export const HERO_N = {
  eyebrow: "Plonge dans",
  title1: "L'École des",
  title2: "Maîtres Dauphins",
  subtitle:
    "Un chemin pour vibrer plus fort, aimer ta vie… et, si tu le choisis, transmettre cette fréquence.",
  para1: "Pour toi qui veux retrouver la joie, la fluidité et le sens.",
  para2: "Pour toi qui veux accompagner avec intégrité et puissance.",
  image:
    "https://images.unsplash.com/photo-1674030572169-66f3a755b8d5?crop=entropy&cs=srgb&fm=jpg&q=90&w=1100&ixlib=rb-4.1.0",
};

export const WELCOME = {
  eyebrow: "Bienvenue",
  title: "Bienvenue dans le Portail Océanique",
  paras: [
    "Tu entres dans un espace où les dauphins maîtres t'attendent. Leur fréquence est celle de la joie pure, de la fluidité totale, et de la connexion au divin.",
    "Ce n'est pas une formation « de plus ». C'est un chemin initiatique. Une École où tu ne viens pas pour apprendre, mais pour te souvenir.",
  ],
};

export const PARCOURS = {
  format: {
    title: "Format",
    items: [
      "14 modules vidéo (1h à 1h30 chacun)",
      "Guidances audio pour chaque dauphin",
      "Support PDF téléchargeable",
      "Accès illimité à vie",
    ],
  },
  rythme: {
    title: "Rythme",
    items: [
      "1 module par semaine recommandé",
      "À ton rythme (flexible)",
      "Live mensuel Q&A avec Gilles",
      "Communauté active 24/7",
    ],
  },
};

export const JOIE = {
  title: "La joie n'est pas un bonus",
  paras: [
    "C'est ton état naturel. Tu l'as juste oublié sous les couches de conditionnement, de blessures, de « il faut que ».",
    "Dans cette école, tu ne vas pas « chercher » la joie. Tu vas retirer ce qui l'empêche de rayonner. C'est la différence entre ajouter du maquillage et nettoyer un miroir. Le dauphin ne cherche pas la joie : il EST la joie. Et c'est ce que tu vas redevenir.",
  ],
};

export const BLOCAGES = [
  { title: "Mémoires transgénérationnelles", text: "Ces poids invisibles que tu portes sans même savoir d'où ils viennent.", icon: "Dna" },
  { title: "Blessures d'amour", text: "Ces cicatrices qui t'empêchent de t'ouvrir pleinement.", icon: "HeartCrack" },
  { title: "Colères enfouies", text: "Cette rage silencieuse qui te ronge de l'intérieur.", icon: "Flame" },
  { title: "Peurs de l'incarnation", text: "Ce refus inconscient d'être pleinement présent·e à la vie.", icon: "Ghost" },
];

const FREQ_DESC = {
  1: "Tu t'ancres profondément et dépasses les dénis d'incarnation, tout en libérant les mémoires familiales qui te pèsent.",
  2: "Tu renoues avec l'intelligence de ton corps et actives ton chakra sacré afin d'apprivoiser tes peurs.",
  3: "Tu lâches ton besoin de contrôle pour passer à l'art de la maîtrise et accueillir ta colère avec justesse.",
  4: "Tu entres dans un portail dimensionnel puissant grâce au pouvoir de ta respiration qui renforce corps et mental.",
  5: "Tu te connectes à la conscience de la Mère divine pour vivre une expérience d'amour inconditionnel.",
  6: "Une rencontre émouvante avec ton enfant intérieur et toute la joie, l'innocence et la spontanéité qu'il porte.",
  7: "Tu agis sur ton chakra de la gorge pour oser t'exprimer de la meilleure façon qui soit.",
  8: "Tu es prêt·e à recevoir des guidances de ton Moi supérieur et à activer ta clairvoyance.",
  9: "LA fréquence delphique pour t'accompagner lors d'une transition difficile ou d'un nouveau départ.",
  10: "Un véritable saut quantique qui te permet de renouer avec ta mission d'âme.",
  11: "Des noces alchimiques : du plomb à l'or, tu vis une transmutation de tes ombres en lumière.",
  12: "Nettoyage complet : ces fréquences éliminent tout ce qui peut affecter ton bien-être.",
  13: "Ces fréquences unifient tous tes chakras et corps subtils pour toucher un état d'unité.",
  14: "Tu harmonises ton corps, ton esprit et ton âme pour atteindre un état d'alignement total.",
};

export const FREQ_LIST = MODULES.map((m) => ({ ...m, desc: FREQ_DESC[m.n] }));

export const TESTIMONIALS_N = [TESTIMONIALS[3], TESTIMONIALS[4], TESTIMONIALS[5]];

export const BONUS_N = [BONUS[0], BONUS[1]];

export const ABOUT_N = {
  name: "Gilles Delieuze",
  role: "Mentor · Auteur · Enseignant",
  image: "https://gillesdelieuze.com/wp-content/uploads/2024/03/IMG_0258_www.vincentphotographie.com_-1024x683.jpg",
  paras: [
    "Cela fait 27 ans que j'accompagne des personnes en quête d'un mieux-être et 18 ans que je suis un expert Dauphins.",
    "« Je sais la souffrance que cela génère de ne pas se sentir à sa place. D'être bloqué dans des schémas répétitifs. »",
    "En 2007, je reçois un « appel » mystique à 3h33. Une énergie se présente à moi sous le nom de « Maîtres Dauphins ». Cet appel m'a permis de sortir la tête de l'eau.",
  ],
};

export const PRICING_N = {
  classique: {
    label: "Formule Classique",
    name: "École des Maîtres Dauphins",
    price: 2222,
    note: "Paiement x1, x2, x3, x5, x10 ou x12",
    features: [
      "Formation complète avec accès illimité",
      "Modules de soins énergétiques",
      "5 fréquences bonus (Baleine, Béluga, Méduse, Hippocampe, Raie)",
      "Live Mensuel",
      "Bonus Dauphins hybrides",
      "Accès communauté active",
    ],
  },
  vip: {
    label: "Formule VIP",
    name: "École des Maîtres + Mentorat 1to1",
    price: 3333,
    note: "Paiement x1, x2, x3",
    features: [
      "Tout de la formule Classique",
      "Fil d'urgence prioritaire",
      "Mentorat 1to1 : 3 RDV d'1h30 avec Gilles",
    ],
  },
};

export const INCLUDED = [
  { title: "14 modules vidéo", text: "1h à 1h30 chacun, accessibles à vie", icon: "PlayCircle" },
  { title: "Guidances audio", text: "Pour chaque dauphin, à écouter en boucle", icon: "Headphones" },
  { title: "Supports PDF", text: "Téléchargeables et imprimables", icon: "FileText" },
  { title: "Communauté active", text: "Groupe privé avec les autres membres", icon: "Users" },
  { title: "Lives mensuels", text: "Q&A avec Gilles en direct", icon: "Radio" },
  { title: "Accès illimité", text: "À vie, à ton rythme", icon: "Infinity" },
];

export const FAQ_N = [
  { q: "À qui s'adresse cette formation ?", a: "À toute personne qui souhaite retrouver sa joie intérieure et/ou accompagner les autres avec une approche énergétique puissante. Aucun prérequis n'est nécessaire." },
  { q: "Combien de temps dure la formation ?", a: "L'accès est illimité dans le temps. Tu peux suivre les modules à ton rythme, revenir autant de fois que nécessaire." },
  { q: "Puis-je payer en plusieurs fois ?", a: "Oui ! Nous proposons des paiements en 2, 3, 5, 10 ou 12 fois pour faciliter l'accès à la formation." },
  { q: "Quelle est la garantie ?", a: "Tu disposes de 14 jours pour tester la formation. Si elle ne te convient pas, tu es remboursé intégralement, sans conditions." },
  { q: "Quelle est la différence entre Classique et VIP ?", a: "La formule VIP inclut tout ce qui est dans Classique, plus 3 séances individuelles d'1h30 avec Gilles pour un accompagnement personnalisé et un fil d'urgence prioritaire." },
];
